import { FC, PropsWithChildren } from 'react';
import {
  PageContentLayout,
  PageHeaderLayout,
  SideMenu,
} from 'melp-design/components';
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useRouteMatch } from 'react-router-dom';
import { ROUTES } from 'config';

export const TransmissionActsLayout: FC<PropsWithChildren<{}>> = ({
  children,
}) => {
  const { t } = useTranslation();
  const { path } = useRouteMatch();

  return (
    <Stack gap={2}>
      <PageHeaderLayout
        breadcrumbs={[
          {
            label: t('transmissionActs.title', { count: 2 }),
          },
        ]}
      />

      <PageContentLayout
        sidebar={
          <SideMenu
            tabs={[
              {
                key: 'transmissionActs',
                label: t('transmissionActs.title', { count: 2 }),
                url: ROUTES.transmissionActs.list,
                isActive: path === ROUTES.transmissionActs.list,
              },
            ]}
          />
        }
      >
        {children}
      </PageContentLayout>
    </Stack>
  );
};
